import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main_layout" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"flex":"1","background-color":"#f5f5f5","padding":"24px 24px 24px 24px"} }
const _hoisted_4 = { class: "content-body" }
const _hoisted_5 = {
  class: "pending_content",
  style: {"margin-top":"8px"}
}
const _hoisted_6 = {
  class: "search-equals",
  style: {"display":"flex","align-items":"center","margin-bottom":"16px"}
}
const _hoisted_7 = { class: "content-table" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  style: {"cursor":"pointer"}
}
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Topbar = _resolveComponent("Topbar")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_MbolWarning = _resolveComponent("MbolWarning")!
  const _component_ClockCircleOutlined = _resolveComponent("ClockCircleOutlined")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_FileProtectOutlined = _resolveComponent("FileProtectOutlined")!
  const _component_T86 = _resolveComponent("T86")!
  const _component_FileUnknownOutlined = _resolveComponent("FileUnknownOutlined")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_spin, { spinning: _ctx.loadingType }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Topbar, { onCustomEvent: _ctx.show_loading }, null, 8, ["onCustomEvent"]),
        _createVNode(_component_a_modal, {
          open: _ctx.showFrame,
          "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showFrame) = $event)),
          title: "Bill Infos",
          class: "bill-iframe",
          width: "950px",
          height: "500px",
          footer: null,
          onAfterClose: _ctx.modalCloseHandle,
          destroyOnClose: true
        }, {
          default: _withCtx(() => [
            (_ctx.showLoading)
              ? (_openBlock(), _createBlock(_component_a_spin, {
                  key: 0,
                  class: "loading-spin",
                  size: "large"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("iframe", {
              src: _ctx.iframe_url,
              class: "iframe-class",
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.frameLoaded && _ctx.frameLoaded(...args))),
              ref: "iframeComp"
            }, null, 40, _hoisted_2)
          ]),
          _: 1
        }, 8, ["open", "onAfterClose"]),
        _createVNode(_component_a_modal, {
          open: _ctx.isShowWarningInfo,
          "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowWarningInfo) = $event)),
          title: _ctx.WarningBills,
          footer: null,
          destroyOnClose: true,
          width: "800px",
          "wrap-class-name": "warning-modal"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MbolWarning, { selectWarningItem: _ctx.selectWarningItem }, null, 8, ["selectWarningItem"])
          ]),
          _: 1
        }, 8, ["open", "title"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.activeKey,
              "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeKey) = $event)),
              class: "tabs-a"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, { key: "1" }, {
                  tab: _withCtx(() => [
                    _createVNode(_component_ClockCircleOutlined),
                    _cache[6] || (_cache[6] = _createTextVNode("Pending "))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { style: {"vertical-align":"middle"} }, "MBOL:", -1)),
                        _createVNode(_component_a_input_search, {
                          value: _ctx.bill_search,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill_search) = $event)),
                          placeholder: "Search",
                          onSearch: _ctx.searchMbolHanlde,
                          style: {"vertical-align":"middle","margin-left":"20px","width":"240px"},
                          allowClear: ""
                        }, null, 8, ["value", "onSearch"]),
                        _cache[8] || (_cache[8] = _createElementVNode("label", { style: {"margin-left":"24px","vertical-align":"middle"} }, "OriginCarries:", -1)),
                        _createVNode(_component_a_select, {
                          ref: "select",
                          value: _ctx.carriesName,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.carriesName) = $event)),
                          style: {"width":"200px","text-align":"left","margin-left":"12px"},
                          onChange: _ctx.handleCarrierChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carriesData, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.key,
                                value: item.text
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.text), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_table, {
                          dataSource: _ctx.mbols_data,
                          columns: _ctx.columns_info,
                          pagination: _ctx.pageData,
                          scroll: { x: 'max-content' },
                          onChange: _ctx.tableChangeHandle
                        }, {
                          bodyCell: _withCtx(({ column, record, index}) => [
                            (column.key === 'actions')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createVNode(_component_a_popconfirm, {
                                    title: "Are you sure pass this task?",
                                    placement: "bottom",
                                    "cancel-text": "No",
                                    onConfirm: ($event: any) => (_ctx.approveHandle(record)),
                                    "ok-text": "Yes"
                                  }, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createElementVNode("a", { href: "#" }, "Approve", -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["onConfirm"]),
                                  _createVNode(_component_a_divider, { type: "vertical" }),
                                  _createVNode(_component_a_popconfirm, {
                                    title: "Are you sure reject this task",
                                    placement: "bottom",
                                    "cancel-text": "No",
                                    "ok-text": "Yes",
                                    okType: "primary",
                                    onConfirm: ($event: any) => (_ctx.rejectHandle(record))
                                  }, {
                                    description: _withCtx(() => [
                                      _createVNode(_component_a_form, { layout: "vertical" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, { label: "Reject reseaon:" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_textarea, {
                                                rows: 3,
                                                ref: "rejectRef",
                                                placeholder: "Please enter reject reason",
                                                value: record.rejectContent,
                                                "onUpdate:value": ($event: any) => ((record.rejectContent) = $event)
                                              }, null, 8, ["value", "onUpdate:value"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[10] || (_cache[10] = _createElementVNode("a", { href: "#" }, "Reject", -1))
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]))
                              : (column.key === 'firstLogisticsProviderName')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (record.firstLogisticsProviderName === null)
                                      ? (_openBlock(), _createBlock(_component_a_select, {
                                          key: 0,
                                          value: record.firstLogisticsProviderName,
                                          style: {"width":"120px","text-align":"left"},
                                          onChange: (value)=> _ctx.setItemFirstProvider(value, record, index)
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carrierItemData, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                                key: item.key,
                                                value: item.text
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.text), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onChange"]))
                                      : (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(record.firstLogisticsProviderName), 1))
                                  ], 64))
                                : (column.key === 'mbol')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      (record.source==='API')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createElementVNode("a", {
                                              href: "javascript:void(0)",
                                              onClick: ($event: any) => (_ctx.showIframe(record))
                                            }, _toDisplayString(record.mbol), 9, _hoisted_11),
                                            _createVNode(_component_CopyOutlined, {
                                              onClick: ($event: any) => (_ctx.copyMbolHandle(record.mbol)),
                                              style: {"margin-left":"8px","color":"#1677ff"}
                                            }, null, 8, ["onClick"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createTextVNode(_toDisplayString(record.mbol) + " ", 1),
                                            _createVNode(_component_CopyOutlined, {
                                              onClick: ($event: any) => (_ctx.copyMbolHandle(record.mbol)),
                                              style: {"margin-left":"8px","color":"#1677ff"}
                                            }, null, 8, ["onClick"])
                                          ]))
                                    ], 64))
                                  : (column.key === 'warning')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        (record.warningCount != null && record.warningCount > 0 )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _createVNode(_component_a_badge, {
                                                status: "warning",
                                                text: `Warning ${record.warningCount}`,
                                                onClick: ($event: any) => (_ctx.showWarningDetail(record))
                                              }, null, 8, ["text", "onClick"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_14, " - "))
                                      ], 64))
                                    : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["dataSource", "columns", "pagination", "onChange"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, { key: "2" }, {
                  tab: _withCtx(() => [
                    _createVNode(_component_FileProtectOutlined),
                    _cache[11] || (_cache[11] = _createTextVNode(" T86 "))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_T86, { onCustomEvent: _ctx.show_loading }, null, 8, ["onCustomEvent"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "3",
                  disabled: ""
                }, {
                  tab: _withCtx(() => [
                    _createVNode(_component_FileUnknownOutlined),
                    _cache[12] || (_cache[12] = _createTextVNode("Reject "))
                  ]),
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createTextVNode(" Reject"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}